<ng-container *ngIf="state$ | async as state">
  <div [class.column--hidden]="!(isSubCategorySelected$ | async) || !(activeSubCategory$ | async)?.teasers?.length ||
  !(activeSubCategory$ | async)"
       class="flyout2-column column-4"
       data-cy="navigation-flyout-column-4"
  >
    <ul class="structure">
      <li *ngFor="let productCategory of (navigation$ | async)?.[0]?.children?.[0]?.children; index as i"
          [attr.data-target]="'products_' + productCategory?.label?.toLowerCase()?.replaceAll(' ', '-')"
          [class.open]="(activeSubCategory$ | async)?.id === productCategory?.id && productCategory?.teasers?.length &&
          (areTeasersVisible$ | async)"
          data-cy="'navigation-flyout-column-4-item"
      >
        <div class="flyout2-teasers">
          <ng-container *ngFor="let teaser of productCategory.teasers; index as ib">
            <mb-link *ngIf="teaser.isVisible"
                     [dataCy]="'flyout-teaser-subcategory-' + i + '-teaser-' + ib"
                     [dataEventAction]="teaser.dataEventAction"
                     [linkData]="{ url: teaser.link?.url, anchor: teaser.link?.anchor, target: teaser.link?.target,
                                   tooltip: teaser.link?.tooltip,
                                   uid: teaser.link?.url?.includes('http') || teaser.link?.url?.includes('http') ? 'url' : 'content_link' }"
                     [useSlot]="true"
                     (click)="closeEvent.emit($event)"
                     styleClass="flyout2-teaser"
                     dataEventCategory="TopNavi Teaser"
            >
              <figure>
                <mb-picture [dataCy]="'flyout-teaser-category-' + i + '-teaser-' + ib"
                            [img]="teaser.image"
                            [srcSet]="[{ mediaQuery: mediaQuery.MIN_WIDTH_992, src: imageSize.XS },
                             { mediaQuery: mediaQuery.MIN_WIDTH_500, src: imageSize.SM },
                             { mediaQuery: mediaQuery.MAX_WIDTH_499, src: imageSize.XS }]"
                            dataPlaceholderBackground="grey"
                >
                  <figcaption [innerHTML]="teaser.caption | safeHtml"></figcaption>
                </mb-picture>
              </figure>
            </mb-link>
          </ng-container>
        </div>
      </li>
    </ul>
  </div>
</ng-container>

